import * as financeAPI from "@/api/accountFinance.api"
import moment from "moment"

export const checkHasFinanceData = async ({ commit }, accountKey) => {
  try {
    const hasFinancialData = await financeAPI.hasData(accountKey)

    commit("setHasFinanceData", hasFinancialData)
  } catch (e) {
    console.log(e)
    commit("setHasFinanceData", false)
  }
}

export const getFinanceData = async ({ commit }, { accountKey, from, to }) => {
  try {
    const diffInDays = moment(to).diff(moment(from), "days")
    const frequency = diffInDays >= 31 ? "monthly" : "daily"

    const financeData = await financeAPI.getData(accountKey, frequency, { from, to })

    commit("setFinancePeriod", { from, to, frequency })
    commit("setFinanceData", financeData)
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const fetchInvoiceSettings = async ({ commit }, accountKey) => {
  try {
    const invoiceSettings = await financeAPI.getInvoiceSettings(accountKey)

    commit("setInvoiceSettings", invoiceSettings)
  } catch (e) {
    console.log(e)
    throw e
  }
}

export const updateInvoiceSettings = async ({ commit }, data) => {
  try {
    const settings = await financeAPI.updateInvoiceSettings(data)

    commit("setInvoiceSettings", settings)
  } catch (e) {
    console.log(e)
    throw e
  }
}
